import { Component, OnInit, Inject } from '@angular/core';
import { Paiement } from '../models/Paiement.model';
import { Facture } from '../models/Facture.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommandeService } from '../_services/commande.service';
import { PaiementService } from '../_services/paiement.service';
import { FactureService } from '../_services/facture.service';
import { Commande } from '../models/Commande.model';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  avance= null;
  restant = null;
  NewAvance= null;
  TotalAvance = null;
  TotalCommande: number;
  paiement: Paiement;
  facture: Facture;
  constructor(private dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private commandeService: CommandeService,
    private paimenetService: PaiementService,
    private factureService: FactureService,
    public dialogRef: MatDialogRef<PaymentComponent>, @Inject(MAT_DIALOG_DATA) public commande: Commande) { }

  ngOnInit(): void {
    this.paiement = new Paiement();
    this.facture = new Facture();
    this.TotalCommande = this.commande.montant;
    this.avance = this.commande.avance;
    this.restant = this.TotalCommande - this.avance;
  }

  getRestant(){
    this.restant = 0;
    this.restant = this.TotalCommande - this.avance - this.NewAvance;
  }
  public close(message): void {
    this.dialogRef.close(message);
  }

  PayAvance(){
    this.spinner.show();
    this.TotalAvance = this.avance + this.NewAvance;
    if(this.TotalCommande != this.TotalAvance){
      this.paiement.datePaiement = new Date();
      this.paiement.type = 'Avance';
      this.paiement.montant = this.NewAvance;
    }else{
      this.paiement.datePaiement = new Date();
      this.paiement.type = 'Complet';
      this.paiement.montant = this.NewAvance;
    }
    console.log("tOTAL AVANCE",this.TotalAvance);
    this.commande.avance = this.TotalAvance;
    console.log("Updating Commande",this.commande);
    this.commandeService.UpdateAvance(this.commande.id,this.NewAvance)
    .subscribe((commandeUpdated) => {
      console.log("UpdateCommande",commandeUpdated);
      if(commandeUpdated){
        this.paimenetService.insertData(this.paiement)
        .subscribe((paiementCreated) => {
          console.log("paiementCreated",paiementCreated);
          if(paiementCreated){
          //Creation Facture
          this.facture.dateFact = new Date();
          this.facture.commande = this.commande;
          //this.facture.numero = '001';
          this.facture.paiement = paiementCreated;
          console.log("InsertedFacture", this.facture);
          this.factureService.insertData(this.facture)
          .subscribe((factureCreated) => {
          console.log("factureCreated",factureCreated);
          this.spinner.hide();
          this.close("Done");
          });
        }
      });
      }
    });
  }


}
